import type { PaymentActionPromise } from '../services/billingApi';

/** O que a efetivação faz com as outras faturas. Sem `_ALL`, só a fatura anterior; com `_ALL`,
 *  todas as faturas abertas do título. */
export const PAYMENT_ACTION_PROMISE_LABELS: Record<PaymentActionPromise, string> = {
    NOTHING: 'Nada — as outras faturas continuam como estão',
    CANCEL: 'Cancelar a fatura anterior',
    CANCEL_ALL: 'Cancelar as outras faturas abertas do título',
    UNCOLLECT: 'Deixar de cobrar a fatura anterior',
    UNCOLLECT_ALL: 'Deixar de cobrar as outras faturas abertas do título',
};

export const paymentActionPromiseLabel = (promise: string | null | undefined): string =>
    (promise && PAYMENT_ACTION_PROMISE_LABELS[promise as PaymentActionPromise]) || promise || '-';
